import React from 'react'
import getConfig from '../../Helpers/getConfig'
import AdvertisingSlot from '../Advertising/AdvertisingSlot'
import './index.css'

const bannerHandler = (isMobile, banner, index, onClick, onImpression, onView, onVisible) => {
  const baseUrl = `${getConfig('storageBaseUrl')}/`
  const imageUrl = banner.advisor ? banner.image : `${baseUrl}banners/${banner.image}`
  return (
    <AdvertisingSlot
      key={`key-${index}`}
      isMobile={isMobile}
      advisor={banner.advisor}
      onClick={onClick}
      onImpression={onImpression}
      onView={onView}
      onVisible={onVisible}
      extraProps={{
        ...banner,
        index,
      }}
      single
    >
      <img
        alt={`banner-${index}`}
        src={imageUrl}
        className="banners-carousel__img"
        width={isMobile ? 720 : 2880}
        height={isMobile ? 720 : 840}
      />
    </AdvertisingSlot>
  )
}

export default bannerHandler
